import styled from 'styled-components'
import { useState, useEffect } from 'react'
import { ContentWidth, TextWidth } from '@ta-interaktiv/react-disco-grid'
import { FortuneChart } from 'components/FortuneChart'
import { FortuneArrow } from 'components/ListItem/FortuneArrow'
import { GrNew } from 'react-icons/gr'
import { BsArrowRight } from 'react-icons/bs'

const Summary = ({ personId }: { personId?: string }) => {
  const [data, setData] = useState<Person[]>([])
  const [person, setPerson] = useState<Person | null>(null)
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    fetch(
      'https://storage.googleapis.com/wch-interactive/bilan-300-plus-riches/people-2025.json'
    )
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok')
        }
        return response.json()
      })
      .then((data) => {
        setData(data)
        setIsLoading(false)
      })
      .catch((error) => {
        setError(error)
      })
  }, [])

  useEffect(() => {
    // const randomPersonId = data[Math.floor(Math.random() * data.length)]?.id

    const personData = data.find((p: Person) => p.id === personId)
    // const personData = data.find((p: Person) => p.id === randomPersonId)
    setPerson(personData || null)
  }, [personId, data])

  const sectors = [person?.mainSector || [], ...(person?.sectors || [])]

  return (
    <Container>
      <TextWidth>
        <Content>
          <TitleHeader>Les 300 plus riches</TitleHeader>
          <Title>{person?.name}</Title>
          {person?.businessName && (
            <BusinessName>{person?.businessName}</BusinessName>
          )}
          {isLoading && <div>Chargement...</div>}
          {error && <div>Erreur</div>}
          {person && (
            <>
              <Table>
                <Row>
                  <Label>Résidence</Label>
                  {person.residence.join(', ')}
                </Row>

                <Row style={{ textTransform: 'capitalize' }}>
                  <Label>Secteur{sectors.length > 1 ? 's' : ''}</Label>
                  {sectors
                    .map((sector) =>
                      sector === 'Horlogerie' ? 'Luxe et horlogerie' : sector
                    )
                    .join(', ')}
                </Row>

                <Row style={{ gridColumn: '1/3' }}>
                  <Label>Fortune</Label>
                  {person.formattedFortune}{' '}
                  <FortunArrowContainter>
                    {person.fortuneEvolution === 'new' && (
                      <NewLabel>NOUVEAU</NewLabel>
                    )}
                    <FortuneArrow
                      inverted
                      fortuneEvolution={person.fortuneEvolution}
                    />
                  </FortunArrowContainter>
                </Row>
              </Table>
              {person.fortuneEvolution !== 'new' && (
                <>
                  <FortuneChart rawData={person?.fortunes || []} />
                </>
              )}
            </>
          )}
          {/* <img
            alt='Logo des 300 plus riches de Suisse'
            src={require(`../../images/teaser.gif`)}
          /> */}
          {/* <Teaser>
            <Button href='https://www.bilan.ch/342217367665'>
              Toute la liste <BsArrowRight style={{ marginLeft: '10px' }} />
            </Button>
          </Teaser> */}
        </Content>
      </TextWidth>
    </Container>
  )
}

const TitleHeader = styled.div`
  color: ${({ theme }) => theme.colorMain};
  font-size: 0.75em;
  font-family: var(--font-sans-serif);
  font-weight: 800;
`

const BusinessName = styled.div`
  line-height: 1.2;
  font-family: var(--font-sans-serif);
`

const Title = styled.div`
  font-family: var(--font-serif);
  line-height: 1.2;
  margin-bottom: 4px;
  font-size: 1.5em;
  font-weight: bold;
`

const Teaser = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 60px;
  font-size: 0.8em;
  font-family: var(--font-sans-serif);
`

const Container = styled.div`
  -webkit-font-smoothing: antialiased;
  margin-bottom: 30px;
`

const Button = styled.a`
  &:hover {
    opacity: 0.8;
  }

  text-decoration: none;
  cursor: pointer;
  background-color: ${({ theme }) => theme.colorMain};
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-family: var(--font-sans-serif);
  white-space: nowrap;
  padding: 5px 20px;
`

const Content = styled.div`
  background-color: ${({ theme }) => `${theme.grayColor}55`};
  color: ${({ theme }) => theme.textColor};
  padding: 20px;
  font-family: vat(--font-serif);
`

const NewLabel = styled.div`
  font-size: 0.65em;
  position: relative;
  background-color: ${({ theme }) => theme.colorMain};
  color: ${({ theme }) => theme.textColorInverted};
  z-index: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  padding: 2px 9px;
  -webkit-font-smoothing: auto;

  path {
    stroke: white;
  }
`

const FortunArrowContainter = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
  font-size: 1.2em;
  margin-left: 20px;
  transform: translateY(-4px);
`

const Table = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 20px;
  margin-top: 30px;
  margin-bottom: 20px;
  background-color: ${({ theme }) => `${theme.siteBackground}`};
  padding: 15px;
  padding-bottom: 0;
`
const Row = styled.div`
  line-height: 1.2;
  border-bottom: 1px solid #00000011;
  padding-bottom: 15px;
  color: ${({ theme }) => theme.textColor};
  font-family: var(--font-sans-serif);

  &:last-child {
    border-bottom: 0;
  }
`

const Label = styled.div`
  text-transform: uppercase;
  font-size: 0.65em;
  margin-bottom: 6px;
  font-family: var(--font-sans-serif);
  font-weight: 400;
  letter-spacing: 0.025em;
  opacity: 0.35;
`

export default Summary
